import React from "react"

const UserActionAuditTrailContext = React.createContext(null)

export default UserActionAuditTrailContext
